import React, { useState } from "react";
import './App.css';


function App() {

  const [popup, setPopup] = useState([false, '', ''])
  const SentBanner = ({name, phone})=> {
    return (<div className='absolute border-2 border-red-600 w-1/3 popup bg-green-500 rounded-xl text-center text-black text-xl'><h1>Hello  {name} <br></br>operator will call u on  {phone}</h1>
    <button className="absolute close-btn" onClick={()=> setPopup([false, '', ''])}>X</button></div>)
  }

  const handleSubmit= (event)=> {
    event.preventDefault()
    const name = event.target[0].value
    const phoneNumber = event.target[1].value
    const city = event.target[2].value
    const district = event.target[3].value

    if (name && phoneNumber && city && district){
      console.log(`Hey ${name} we will call u on ${phoneNumber} soon`)
      setPopup(()=> [true, name, phoneNumber])
    }
  }
  return (
    <>
    <div className='h-screen grid grid-flow-row grid-rows-6 '>
    <h1 className = 'lg:text-8xl text-5xl text-center logoName font-mono pt-6'>Chipo order-delivery</h1>
    <div className='row-span-5 flex justify-center'>
      <form className='flex flex-col md:w-1/2 w-full m-10 border-2 text-black items-center gap-10 rounded-2xl form-css'
      onSubmit={(e)=> handleSubmit(e)}
      >
      <h1 className='text-2xl lg:text-4xl mt-8 md:w-1/2 w-full text-center font-mono font-bold'>Order your chip</h1>
      <input placeholder='Enter your name' className='md:w-1/2 w-60 border-2 border-gray-700 rounded p-2'></input>
      <input placeholder='Enter your Phone number' className='md:w-1/2 w-60 border-2 border-gray-700 rounded p-2'></input>
      <select className='md:w-1/2 w-60 border-2 border-gray-700 rounded p-2'>
      <option value=''>Select your city</option>
      <option value="Tbilisi">Tbilisi</option>
      </select>
      <select className='md:w-1/2 w-60 border-2 border-gray-700 rounded p-2'>
      <option value=''>Select your District</option>
      <option value="Gldani">Gldani</option>
      <option value="Vake">Vake</option>
      <option value="Saburtalo">Saburtalo</option>
      <option value="Didube">Didube</option>
      </select>
      <button className='border-2 border-gray-700 bg-green-600 rounded pt-2 pb-2 md:w-1/2 w-60'
      type='submit'
      >Submit</button>
      
      </form>
    </div>
    </div>
    {popup[0]? <SentBanner name={popup[1]} phone={popup[2]}> </SentBanner>: ''}

    </>
  );
}

export default App;
